export default __webpack_public_path__ + "static/media/offline.0f926f1f.svg";